import { render, staticRenderFns } from "./SendCurrencyContainer.vue?vue&type=template&id=b8183d42&scoped=true&"
import script from "./SendCurrencyContainer.vue?vue&type=script&lang=js&"
export * from "./SendCurrencyContainer.vue?vue&type=script&lang=js&"
import style0 from "./SendCurrencyContainer.vue?vue&type=style&index=0&id=b8183d42&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8183d42",
  null
  
)

export default component.exports